export default {
  title: 'Deliverect',
  form: {
    channel_link_id: {
      label: 'Kanavalinkin tunnus: ',
    },
    store_id: {
      label: 'Ulkoisen sijainnin tunnus: ',
    },
    store_provisioning_url: {
      label: 'Myymälän käyttöönoton URL-osoite: ',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    error: 'Muutosten tallentaminen epäonnistui',
    success: 'Muutokset tallennettiin',
  },
  instructions: {
    title: 'Käyttöönotto-ohjeet:',
    step_1:
      'Avaa Deliverectin <Link>"Locations"</Link>-sivu, laajenna oikea sijainti ja napsauta "+ Channel link" -painiketta.',
    step_2:
      'Täytä tarvittavat tiedot. Valitse kohdassa "Select your online delivery platform" vaihtoehto "Food Amigos".',
    step_3: 'Viimeistele kaikki vaiheet. Napsauta sitten "Locations"-sivulla "Food Amigos" -kanavan kohdalla "Edit".',
    step_4: 'Napsauta sivupalkissa "Channel connection" -välilehteä ja täytä nämä tiedot:',
    step_5: 'Tallenna muutokset napsauttamalla "Save"-painiketta oikeassa yläkulmassa.',
    step_6:
      'Kun tallennus on valmis, napsauta "More"-kuvaketta oikeassa yläkulmassa, sitten "Register" ja sen jälkeen "Activate".',
    step_7: 'Palaa "General"-välilehteen, vaihda "Integration status" tilaan "Active" ja tallenna muutokset.',
    outro: 'Sen jälkeen voit lähettää ruokalistan Deliverectistä ja luoda testitilauksen.',
  },
  connected: {
    title: 'Deliverect on yhdistetty',
    description: 'Tämä integraatio on määritetty.',
  },
};
